import { loadInputImask } from './loadInputImask'

/**
 *
 * @param {HTMLInputElement} input
 */
export function loadVerifiedPhoneIMask(input) {
  loadInputImask(input, {
    mask: '+1 (000) 000-0000',
    lazy: true,
    unmask: true,
    overwrite: 'shift',
  })
}
